// src/js/reducers/index.js
import * as types from "../constants/action-types";
import moment from 'moment';

export default function siteLogSummaryReducer(state = [], action) {
    switch (action.type) {

        case types.LOGOUT:
            return []

        case types.LOAD_SITELOG_SUMMARY_SUCCESS:

            return action.summary;
       
                
        default:
            return state;
    };
};
